import { IntentTagNames, videoTagNames } from '@/features/videos-common/audiences';

/** Filters above the videos table. They narrow only the table. */
export const VideoFilters = Object.freeze({
  All: 'all',
  Educator: 'educator',
  Partner: 'partner',
  Untagged: 'untagged'
});

export const VIDEO_FILTERS = Object.freeze([
  VideoFilters.All,
  VideoFilters.Educator,
  VideoFilters.Partner,
  VideoFilters.Untagged
]);

/**
 * @param {import('@/features/staff-settings-videos/hooks/useStaffVideos').StaffVideo[]} videos
 * @param {string} filter - one of VIDEO_FILTERS
 * @returns {import('@/features/staff-settings-videos/hooks/useStaffVideos').StaffVideo[]}
 */
export default function filterVideos(videos = [], filter = VideoFilters.All) {
  switch (filter) {
    case VideoFilters.Educator:
      return videos.filter((video) => videoTagNames(video).includes(IntentTagNames.Educator));
    case VideoFilters.Partner:
      return videos.filter((video) => videoTagNames(video).includes(IntentTagNames.Partner));
    case VideoFilters.Untagged:
      return videos.filter((video) => videoTagNames(video).length === 0);
    default:
      return videos;
  }
}
